import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { getEnumValues } from '../../../../../services/common/miscUtils';
import { allNaceCodes, allNaceSections } from '../../../../../services/common/naceCodes';
import Yup, {
  maxMobileNumberLength,
  minMobileNumberLength,
  regExEmail,
  regexVat,
} from '../../../../../services/common/validation';
import { CorrespondenceMethodEnum, NoYesEnum } from '../../../../../types/forms';
import { CompanyDetailsFormModel_ST_OL } from './formModel';

export const getValidationSchema = (): ObjectSchema<Partial<CompanyDetailsFormModel_ST_OL>> => {
  return Yup.object({
    tradingName: Yup.string().requiredWithMsg(),
    legalName: Yup.string().requiredWithMsg(),
    fleetSize: Yup.number().requiredWithMsg(),
    dateOfIncorporation: Yup.string().requiredWithMsg(),
    businessType: Yup.string().requiredWithMsg().oneOf(allNaceSections),
    businessSubType: Yup.string().requiredWithMsg().oneOf(allNaceCodes),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    phoneNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
    vatLiable: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    vatNumber: Yup.string().when('vatLiable', {
      is: (vatLiable: NoYesEnum) => vatLiable === NoYesEnum.yes,
      then: (schema) =>
        schema
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10)
          .requiredWithMsg(),
      otherwise: (schema) =>
        schema
          .optional()
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10),
    }),
    correspondenceMethod: Yup.string().requiredWithMsg().oneOf(getEnumValues(CorrespondenceMethodEnum)),
  });
};
